module.exports = __webpack_public_path__ + "img/aero-whatsapp-logo.62b0453b.png";